(function () {
  'use strict';

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, '');
  }

  function makeElement(tagName, className, textValue) {
    var element = document.createElement(tagName);
    if (className) element.className = className;
    if (typeof textValue === 'string') element.textContent = textValue;
    return element;
  }

  function buildStars(score) {
    var stars = makeElement('span', 'product-reviews-custom__stars');
    var parsedRating = parseFloat(score);
    var rating = isFinite(parsedRating) ? Math.max(0, Math.min(5, parsedRating)) : 0;
    var index;
    var star;
    stars.setAttribute('aria-label', rating + ' out of 5 stars');
    stars.setAttribute('role', 'img');
    for (index = 1; index <= 5; index += 1) {
      star = makeElement('span', index <= Math.round(rating) ? 'product-reviews-custom__star--filled' : 'product-reviews-custom__star--empty', '★');
      star.setAttribute('aria-hidden', 'true');
      stars.appendChild(star);
    }
    return stars;
  }

  function buildVerifiedBadge() {
    var badge = makeElement('span', 'product-reviews-custom__verified');
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    icon.setAttribute('viewBox', '0 0 24 24');
    icon.setAttribute('aria-hidden', 'true');
    path.setAttribute('d', 'm7 12 3 3 7-7');
    icon.appendChild(path);
    badge.appendChild(icon);
    badge.appendChild(document.createTextNode('Verified'));
    return badge;
  }

  function buildCard(reviewNode, index) {
    var ratingNode = reviewNode.querySelector('.jdgm-rev__rating');
    var titleNode = reviewNode.querySelector('.jdgm-rev__title');
    var bodyNode = reviewNode.querySelector('.jdgm-rev__body');
    var authorNode = reviewNode.querySelector('.jdgm-rev__author');
    var top = makeElement('div', 'product-reviews-custom__card-top');
    var card = makeElement('article', 'product-reviews-custom__card');
    var title = cleanText(titleNode ? titleNode.textContent : '');
    var body = cleanText(bodyNode ? bodyNode.textContent : '');
    var author = cleanText(authorNode ? authorNode.textContent : '') || 'Anonymous';
    var reviewer = makeElement('footer', 'product-reviews-custom__reviewer');
    var score = ratingNode ? ratingNode.getAttribute('data-score') : 0;
    var visibleRating = ratingNode ? cleanText(ratingNode.getAttribute('aria-label')) : '';
    var visibleRatingMatch = visibleRating.match(/([0-5](?:\.\d+)?)\s*(?:out of|\/)/i);

    if (visibleRatingMatch) score = visibleRatingMatch[1];

    card.setAttribute('aria-label', 'Review ' + (index + 1));
    top.appendChild(buildStars(score));
    card.appendChild(top);

    if (title) card.appendChild(makeElement('h3', 'product-reviews-custom__review-title', title));
    if (body) card.appendChild(makeElement('p', 'product-reviews-custom__body', body));

    reviewer.appendChild(makeElement('span', 'product-reviews-custom__author', author));
    if (reviewNode.getAttribute('data-verified-buyer') === 'true') reviewer.appendChild(buildVerifiedBadge());
    card.appendChild(reviewer);
    return card;
  }

  function updateControls(root, rail, cards) {
    var previous = root.querySelector('[data-product-reviews-previous]');
    var next = root.querySelector('[data-product-reviews-next]');
    var maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth - 2);
    if (previous) previous.disabled = rail.scrollLeft <= 2;
    if (next) next.disabled = rail.scrollLeft >= maxScroll;
    if (cards.length > 1) {
      var cardWidth = cards[0].offsetWidth || rail.clientWidth;
      var activeIndex = Math.min(cards.length - 1, Math.max(0, Math.round(rail.scrollLeft / cardWidth)));
      var status = root.querySelector('[data-product-reviews-status]');
      if (status) status.textContent = 'Showing review ' + (activeIndex + 1) + ' of ' + cards.length;
    }
  }

  function moveRail(root, direction) {
    var rail = root.querySelector('[data-product-reviews-rail]');
    var firstCard = rail ? rail.querySelector('.product-reviews-custom__card') : null;
    var amount;
    if (!rail || !firstCard) return;
    amount = firstCard.offsetWidth + 16;
    rail.scrollLeft += direction * amount;
  }

  function renderReviewSection(root) {
    var source;
    var reviewNodes;
    var rail;
    var controls;
    var maxReviews;
    var index;
    var previous;
    var next;
    var onScrollTimer;

    if (!root || root.getAttribute('data-product-reviews-ready') === 'true') return true;
    source = root.querySelector('[data-product-reviews-source]');
    rail = root.querySelector('[data-product-reviews-rail]');
    if (!source || !rail) return false;
    reviewNodes = source.querySelectorAll('.jdgm-rev');
    maxReviews = parseInt(root.getAttribute('data-max-reviews'), 10) || reviewNodes.length;

    if (!reviewNodes.length) return false;

    for (index = 0; index < reviewNodes.length && index < maxReviews; index += 1) {
      rail.appendChild(buildCard(reviewNodes[index], index));
    }

    reviewNodes = rail.querySelectorAll('.product-reviews-custom__card');
    if (!reviewNodes.length) return false;

    root.setAttribute('data-product-reviews-ready', 'true');
    root.setAttribute('aria-busy', 'false');
    root.style.display = '';
    controls = root.querySelector('[data-product-reviews-controls]');
    if (controls && reviewNodes.length > 1) controls.hidden = false;
    previous = root.querySelector('[data-product-reviews-previous]');
    next = root.querySelector('[data-product-reviews-next]');
    if (previous) previous.addEventListener('click', function () { moveRail(root, -1); });
    if (next) next.addEventListener('click', function () { moveRail(root, 1); });
    rail.addEventListener('scroll', function () {
      window.clearTimeout(onScrollTimer);
      onScrollTimer = window.setTimeout(function () { updateControls(root, rail, reviewNodes); }, 80);
    });
    window.addEventListener('resize', function () { updateControls(root, rail, reviewNodes); });
    // The review stylesheet loads asynchronously; recalculate once it is ready.
    window.addEventListener('load', function () { updateControls(root, rail, reviewNodes); });
    updateControls(root, rail, reviewNodes);
    return true;
  }

  function stopWaitingForReviews(root) {
    if (root._productReviewsTimer) {
      window.clearInterval(root._productReviewsTimer);
      root._productReviewsTimer = null;
    }
    if (root._productReviewsObserver) {
      root._productReviewsObserver.disconnect();
      root._productReviewsObserver = null;
    }
    root.removeAttribute('data-product-reviews-waiting');
  }

  function initReviewSection(root) {
    var source;
    var attempts = 0;
    var maxAttempts = 24;

    if (!root || root.getAttribute('data-product-reviews-ready') === 'true') return;
    if (renderReviewSection(root)) return;
    if (root.getAttribute('data-product-reviews-waiting') === 'true') return;

    source = root.querySelector('[data-product-reviews-source]');
    if (!source) {
      root.style.display = 'none';
      root.setAttribute('aria-busy', 'false');
      return;
    }

    root.setAttribute('data-product-reviews-waiting', 'true');
    root._productReviewsTimer = window.setInterval(function () {
      attempts += 1;
      if (renderReviewSection(root)) {
        stopWaitingForReviews(root);
      } else if (attempts >= maxAttempts) {
        stopWaitingForReviews(root);
        root.style.display = 'none';
        root.setAttribute('aria-busy', 'false');
      }
    }, 250);

    if (window.MutationObserver) {
      root._productReviewsObserver = new window.MutationObserver(function () {
        if (renderReviewSection(root)) stopWaitingForReviews(root);
      });
      root._productReviewsObserver.observe(source, { childList: true, subtree: true });
    }
  }

  function initAllReviewSections(container) {
    var scope = container || document;
    var sections = scope.querySelectorAll('[data-product-reviews-custom]');
    var index;
    for (index = 0; index < sections.length; index += 1) initReviewSection(sections[index]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllReviewSections(document); });
  } else {
    initAllReviewSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAllReviewSections(event.target); });
})();
